__turbopack_context__.v({
  "className": "koreannamefont_949daa3c-module__0XCXfa__className",
});
